import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { CopiedSourcingEventDto } from "../../autogen/bff-api";

export const InvitationsLeftOutModal = ({
  copied,
  onOpenCopy,
}: {
  copied: CopiedSourcingEventDto;
  onOpenCopy: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen onClose={onOpenCopy} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("Invitations were left out")}</ModalHeader>
        <ModalBody>
          <Stack spacing={3}>
            <Text>
              {t("{{count}} invitations without an organization were left out.", {
                count: copied.skippedInvitations,
              })}
            </Text>
            <Text>{t("Invite those suppliers again from the copy if they should take part.")}</Text>
            {copied.copiedInvitations > 0 && (
              <Text>
                {t("The other {{count}} invitations were copied. Review them before you publish.", {
                  count: copied.copiedInvitations,
                })}
              </Text>
            )}
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="teal" onClick={onOpenCopy}>
            {t("Open the copy")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
